import RBACFlag from "@/app/components/core/RBACFlag";
import SolidButton from "@/app/components/ui/Buttons/SolidButton";
import InputWithAddOn from "@/app/components/ui/Inputs/InputWithAddOn";
import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";
import DataTable from "@/app/components/ui/Reusable/DataTable";
import SkeletonType1 from "@/app/components/ui/Skeletons/Type1";
import { useConfigurationClinicListTableAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationClinicListTableAPI";
import { useConfigurationModuleSearchAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationModuleSearchAPI";
import { getClinicColumns } from "@/app/hooks/custom_hooks";
import { useLoader } from "@/app/hooks/useLoader";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { IConfigurationListState } from "@/app_redux/reducers/slices/auth/configuration_slice";
import SearchCustomerImage from "@assets/images/search_customer.png";
import { useEffect } from "react";
import { FaClinicMedical } from "react-icons/fa";
import { useNavigate } from "react-router";

const ConfigurationClinicSetup = () => {
  let clinicsFeched = false;
  const { getRouteKey } = useRouter();
  const fetchClinicList = useConfigurationClinicListTableAPI();
  const routeIdConfig = getRouteKey("CONFIGURATION", "id");
  const { routeState } = useRouteInfo(routeIdConfig);
  const { clinicListTable: clinicList } = routeState.state as IConfigurationListState;
  const isEquipmentListInProgress = useLoader("isOnboardEquipmentListInProgress");
  const searchClinic = useConfigurationModuleSearchAPI("clinic");
  const navigate = useNavigate();
  const columns = getClinicColumns(navigate, getRouteKey);

  useEffect(() => {
    if (!clinicsFeched) {
      clinicsFeched = !clinicsFeched;
      fetchClinicList();
    }
  }, [fetchClinicList]);

  return (
    <div className="px-5 py-3">
      <div className="items-center bg-white">
        <div className="flex flex-col">
          <div className="flex justify-between items-center">
            <div className="font-semibold text-base text-black leading-tight">Listed Clinics</div>
            <div>
              <RBACFlag actionId="CLINIC_SETUP_ONBOARD">
                <SolidButton asLink href={getRouteKey("CLINIC_SETUP_ONBOARD", "url")} size="XL">
                  + Add Clinic
                </SolidButton>
              </RBACFlag>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          <InputWithAddOn
            onEnterKeyPress={(query: string) => {
              if (query.length === 0) {
                fetchClinicList();
              } else {
                searchClinic(query);
              }
            }}
            containerClassName="w-1/2"
            addon={<FaClinicMedical className="w-4 h-4" />}
            placeholder="Search Clinic"
          />
        </div>
      </div>
      <div className="mt-3 flow-root">
        {isEquipmentListInProgress ? (
          <div className="mt-8">
            <SkeletonType1 />
            <SkeletonType1 className="mt-4" />
          </div>
        ) : clinicList?.length > 0 ? (
          <div>
            <DataTable data={clinicList || []} columns={columns} maxHeight="640px" />
          </div>
        ) : (
          <NoDataFoundComponent
            imageURL={SearchCustomerImage}
            message="No Clinic Listed"
            description="There are no onboarded clinics, please onboard a few."
          />
        )}
      </div>
    </div>
  );
};

export default ConfigurationClinicSetup;
